// Auto-generated by scripts/bundle-data.mjs - DO NOT EDIT DIRECTLY
import type { DeckManifest } from "../types.ts";

export const DECK_MANIFEST: DeckManifest = Object.freeze({
  categories: Object.freeze([
  "Conspiracies",
  "Crimes",
  "Events",
  "People",
  "Places",
  "Scams",
  "Things"
]),
  cardsByCategory: Object.freeze({
  "Conspiracies": [
    {
      "id": "conspiracies-1",
      "category": "Conspiracies",
      "text": "Flat Earth Society"
    },
    {
      "id": "conspiracies-2",
      "category": "Conspiracies",
      "text": "The Moon Landing Was Faked"
    },
    {
      "id": "conspiracies-3",
      "category": "Conspiracies",
      "text": "Illuminati"
    },
    {
      "id": "conspiracies-4",
      "category": "Conspiracies",
      "text": "Area 51 Aliens"
    },
    {
      "id": "conspiracies-5",
      "category": "Conspiracies",
      "text": "Lizard People"
    },
    {
      "id": "conspiracies-6",
      "category": "Conspiracies",
      "text": "Chemtrails"
    },
    {
      "id": "conspiracies-7",
      "category": "Conspiracies",
      "text": "Birds Aren't Real"
    },
    {
      "id": "conspiracies-8",
      "category": "Conspiracies",
      "text": "5G Microchips in Vaccines"
    },
    {
      "id": "conspiracies-9",
      "category": "Conspiracies",
      "text": "Princess Diana's Assassination"
    },
    {
      "id": "conspiracies-10",
      "category": "Conspiracies",
      "text": "Paul McCartney Is Dead"
    },
    {
      "id": "conspiracies-11",
      "category": "Conspiracies",
      "text": "JFK & The Grassy Knoll Shooter"
    },
    {
      "id": "conspiracies-12",
      "category": "Conspiracies",
      "text": "The New World Order"
    },
    {
      "id": "conspiracies-13",
      "category": "Conspiracies",
      "text": "The Freemasons"
    },
    {
      "id": "conspiracies-14",
      "category": "Conspiracies",
      "text": "The Bermuda Triangle"
    },
    {
      "id": "conspiracies-15",
      "category": "Conspiracies",
      "text": "Hollow Earth Theory"
    },
    {
      "id": "conspiracies-16",
      "category": "Conspiracies",
      "text": "The Loch Ness Monster"
    },
    {
      "id": "conspiracies-17",
      "category": "Conspiracies",
      "text": "Bigfoot (Sasquatch)"
    },
    {
      "id": "conspiracies-18",
      "category": "Conspiracies",
      "text": "Roswell Alien Autopsy"
    },
    {
      "id": "conspiracies-19",
      "category": "Conspiracies",
      "text": "We Live in a Computer Simulation"
    },
    {
      "id": "conspiracies-20",
      "category": "Conspiracies",
      "text": "Elvis Presley Is Still Alive"
    },
    {
      "id": "conspiracies-21",
      "category": "Conspiracies",
      "text": "Tupac Is Alive in Cuba"
    },
    {
      "id": "conspiracies-22",
      "category": "Conspiracies",
      "text": "Secret Nazi Antarctic Base"
    },
    {
      "id": "conspiracies-23",
      "category": "Conspiracies",
      "text": "Aliens Built the Egyptian Pyramids"
    },
    {
      "id": "conspiracies-24",
      "category": "Conspiracies",
      "text": "QAnon"
    },
    {
      "id": "conspiracies-25",
      "category": "Conspiracies",
      "text": "The Deep State Shadow Government"
    },
    {
      "id": "conspiracies-26",
      "category": "Conspiracies",
      "text": "The Great Replacement Theory"
    },
    {
      "id": "conspiracies-27",
      "category": "Conspiracies",
      "text": "The Elders of Zion Protocol"
    },
    {
      "id": "conspiracies-28",
      "category": "Conspiracies",
      "text": "COVID-19 Was Engineered in a Lab"
    },
    {
      "id": "conspiracies-29",
      "category": "Conspiracies",
      "text": "Jeffrey Epstein Didn't Kill Himself"
    },
    {
      "id": "conspiracies-30",
      "category": "Conspiracies",
      "text": "Marilyn Monroe Was Murdered by the CIA"
    },
    {
      "id": "conspiracies-31",
      "category": "Conspiracies",
      "text": "PizzaGate"
    }
  ],
  "Crimes": [
    {
      "id": "crimes-1",
      "category": "Crimes",
      "text": "Cannibalism"
    },
    {
      "id": "crimes-2",
      "category": "Crimes",
      "text": "Grave Robbing"
    },
    {
      "id": "crimes-3",
      "category": "Crimes",
      "text": "Tax Evasion"
    },
    {
      "id": "crimes-4",
      "category": "Crimes",
      "text": "Arson"
    },
    {
      "id": "crimes-5",
      "category": "Crimes",
      "text": "Kidnapping"
    },
    {
      "id": "crimes-6",
      "category": "Crimes",
      "text": "Bank Robbery"
    },
    {
      "id": "crimes-7",
      "category": "Crimes",
      "text": "Identity Theft"
    },
    {
      "id": "crimes-8",
      "category": "Crimes",
      "text": "Blackmail"
    },
    {
      "id": "crimes-9",
      "category": "Crimes",
      "text": "Smuggling"
    },
    {
      "id": "crimes-10",
      "category": "Crimes",
      "text": "Shoplifting"
    },
    {
      "id": "crimes-11",
      "category": "Crimes",
      "text": "Bribery"
    },
    {
      "id": "crimes-12",
      "category": "Crimes",
      "text": "Counterfeit Money"
    },
    {
      "id": "crimes-13",
      "category": "Crimes",
      "text": "Money Laundering"
    },
    {
      "id": "crimes-14",
      "category": "Crimes",
      "text": "Hijacking an Aeroplane"
    },
    {
      "id": "crimes-15",
      "category": "Crimes",
      "text": "Grand Theft Auto"
    },
    {
      "id": "crimes-16",
      "category": "Crimes",
      "text": "Insider Trading"
    },
    {
      "id": "crimes-17",
      "category": "Crimes",
      "text": "Black Market Organ Harvesting"
    },
    {
      "id": "crimes-18",
      "category": "Crimes",
      "text": "Pirating Movies"
    },
    {
      "id": "crimes-19",
      "category": "Crimes",
      "text": "Joyriding"
    },
    {
      "id": "crimes-20",
      "category": "Crimes",
      "text": "Embezzlement"
    },
    {
      "id": "crimes-21",
      "category": "Crimes",
      "text": "Extortion"
    },
    {
      "id": "crimes-22",
      "category": "Crimes",
      "text": "Drug Smuggling"
    },
    {
      "id": "crimes-23",
      "category": "Crimes",
      "text": "Forging a Will"
    },
    {
      "id": "crimes-24",
      "category": "Crimes",
      "text": "Breaking and Entering"
    },
    {
      "id": "crimes-25",
      "category": "Crimes",
      "text": "Vandalism"
    },
    {
      "id": "crimes-26",
      "category": "Crimes",
      "text": "Illegal Arms Dealing"
    },
    {
      "id": "crimes-27",
      "category": "Crimes",
      "text": "Stalking"
    },
    {
      "id": "crimes-28",
      "category": "Crimes",
      "text": "Bribing a Police Officer"
    },
    {
      "id": "crimes-29",
      "category": "Crimes",
      "text": "Smuggling Contraband into Prison"
    },
    {
      "id": "crimes-30",
      "category": "Crimes",
      "text": "The Great Train Robbery"
    },
    {
      "id": "crimes-31",
      "category": "Crimes",
      "text": "Dumping Toxic Waste in a River"
    },
    {
      "id": "crimes-32",
      "category": "Crimes",
      "text": "Hit and Run"
    },
    {
      "id": "crimes-33",
      "category": "Crimes",
      "text": "Poaching Rhino Horns"
    },
    {
      "id": "crimes-34",
      "category": "Crimes",
      "text": "Selling Drugs to Undercover Police"
    },
    {
      "id": "crimes-35",
      "category": "Crimes",
      "text": "Illegal Street Racing"
    },
    {
      "id": "crimes-36",
      "category": "Crimes",
      "text": "Running an Underground Fight Club"
    },
    {
      "id": "crimes-37",
      "category": "Crimes",
      "text": "Rigging an Election"
    },
    {
      "id": "crimes-38",
      "category": "Crimes",
      "text": "Faking Your Own Death"
    },
    {
      "id": "crimes-39",
      "category": "Crimes",
      "text": "Bribing a Judge"
    },
    {
      "id": "crimes-40",
      "category": "Crimes",
      "text": "Forging Passports"
    },
    {
      "id": "crimes-41",
      "category": "Crimes",
      "text": "Swallowing Heroin Balloons"
    },
    {
      "id": "crimes-42",
      "category": "Crimes",
      "text": "Poisoning the Town Water Supply"
    },
    {
      "id": "crimes-43",
      "category": "Crimes",
      "text": "Running a Backyard Meth Lab"
    },
    {
      "id": "crimes-44",
      "category": "Crimes",
      "text": "Hacking the Pentagon"
    },
    {
      "id": "crimes-45",
      "category": "Crimes",
      "text": "Stealing a Marked Police Car"
    },
    {
      "id": "crimes-46",
      "category": "Crimes",
      "text": "Impersonating a Surgeon"
    },
    {
      "id": "crimes-47",
      "category": "Crimes",
      "text": "Armed Robbery at a Drive-Thru"
    },
    {
      "id": "crimes-48",
      "category": "Crimes",
      "text": "Running an Illegal Underground Casino"
    },
    {
      "id": "crimes-49",
      "category": "Crimes",
      "text": "Moonshining (Illegal Moonshine Still)"
    },
    {
      "id": "crimes-50",
      "category": "Crimes",
      "text": "Siphoning Petrol from Strangers' Cars"
    },
    {
      "id": "crimes-51",
      "category": "Crimes",
      "text": "Piracy on the High Seas"
    },
    {
      "id": "crimes-52",
      "category": "Crimes",
      "text": "A Prison Break"
    },
    {
      "id": "crimes-53",
      "category": "Crimes",
      "text": "Necrophilia"
    },
    {
      "id": "crimes-54",
      "category": "Crimes",
      "text": "Assassinating a Head of State"
    },
    {
      "id": "crimes-55",
      "category": "Crimes",
      "text": "Running a Cult"
    },
    {
      "id": "crimes-56",
      "category": "Crimes",
      "text": "Selling a Human Kidney on the Dark Web"
    },
    {
      "id": "crimes-57",
      "category": "Crimes",
      "text": "Faking a Terminal Illness for Donations"
    },
    {
      "id": "crimes-58",
      "category": "Crimes",
      "text": "Impersonating a Police Officer"
    },
    {
      "id": "crimes-59",
      "category": "Crimes",
      "text": "Jury Tampering"
    },
    {
      "id": "crimes-60",
      "category": "Crimes",
      "text": "People Trafficking"
    },
    {
      "id": "crimes-61",
      "category": "Crimes",
      "text": "Burning Down a Church for Insurance"
    },
    {
      "id": "crimes-62",
      "category": "Crimes",
      "text": "Planting Evidence on a Suspect"
    },
    {
      "id": "crimes-63",
      "category": "Crimes",
      "text": "Staging Your Own Death for Life Insurance"
    },
    {
      "id": "crimes-64",
      "category": "Crimes",
      "text": "Poisoning a Business Rival"
    },
    {
      "id": "crimes-65",
      "category": "Crimes",
      "text": "Running a Sex Trafficking Ring"
    },
    {
      "id": "crimes-66",
      "category": "Crimes",
      "text": "Sedition Against the State"
    },
    {
      "id": "crimes-67",
      "category": "Crimes",
      "text": "War Crimes"
    },
    {
      "id": "crimes-68",
      "category": "Crimes",
      "text": "Torture"
    },
    {
      "id": "crimes-69",
      "category": "Crimes",
      "text": "Sheep Rustling"
    },
    {
      "id": "crimes-70",
      "category": "Crimes",
      "text": "Noncing"
    }
  ],
  "Events": [
    {
      "id": "events-1",
      "category": "Events",
      "text": "9/11"
    },
    {
      "id": "events-2",
      "category": "Events",
      "text": "The Titanic"
    },
    {
      "id": "events-3",
      "category": "Events",
      "text": "The Hindenburg Disaster"
    },
    {
      "id": "events-4",
      "category": "Events",
      "text": "The Chernobyl Disaster"
    },
    {
      "id": "events-5",
      "category": "Events",
      "text": "The Holocaust"
    },
    {
      "id": "events-6",
      "category": "Events",
      "text": "The Black Death"
    },
    {
      "id": "events-7",
      "category": "Events",
      "text": "Pompeii"
    },
    {
      "id": "events-8",
      "category": "Events",
      "text": "Hiroshima"
    },
    {
      "id": "events-9",
      "category": "Events",
      "text": "Pearl Harbour"
    },
    {
      "id": "events-10",
      "category": "Events",
      "text": "The Spanish Inquisition"
    },
    {
      "id": "events-11",
      "category": "Events",
      "text": "The Salem Witch Trials"
    },
    {
      "id": "events-12",
      "category": "Events",
      "text": "The Great Depression"
    },
    {
      "id": "events-13",
      "category": "Events",
      "text": "A Nuclear Meltdown"
    },
    {
      "id": "events-14",
      "category": "Events",
      "text": "The Great Fire of London"
    },
    {
      "id": "events-15",
      "category": "Events",
      "text": "Apollo 13"
    },
    {
      "id": "events-16",
      "category": "Events",
      "text": "The Battle of Waterloo"
    },
    {
      "id": "events-17",
      "category": "Events",
      "text": "The Cuban Missile Crisis"
    },
    {
      "id": "events-18",
      "category": "Events",
      "text": "A Volcanic Eruption"
    },
    {
      "id": "events-19",
      "category": "Events",
      "text": "The Boxing Day Tsunami"
    },
    {
      "id": "events-20",
      "category": "Events",
      "text": "The Challenger Disaster"
    },
    {
      "id": "events-21",
      "category": "Events",
      "text": "OceanGate Titan Submersible Implosion"
    },
    {
      "id": "events-22",
      "category": "Events",
      "text": "The Trojan Horse"
    },
    {
      "id": "events-23",
      "category": "Events",
      "text": "The Fall of the Roman Empire"
    },
    {
      "id": "events-24",
      "category": "Events",
      "text": "The Storming of the Bastille"
    },
    {
      "id": "events-25",
      "category": "Events",
      "text": "The Roswell UFO Crash"
    },
    {
      "id": "events-26",
      "category": "Events",
      "text": "The Great Emu War"
    },
    {
      "id": "events-27",
      "category": "Events",
      "text": "The Gunpowder Plot"
    },
    {
      "id": "events-28",
      "category": "Events",
      "text": "The Fall of the Berlin Wall"
    },
    {
      "id": "events-29",
      "category": "Events",
      "text": "The COVID-19 Pandemic"
    },
    {
      "id": "events-30",
      "category": "Events",
      "text": "January 6th (The Capitol Riot)"
    },
    {
      "id": "events-31",
      "category": "Events",
      "text": "The Dunblane School Shooting"
    },
    {
      "id": "events-32",
      "category": "Events",
      "text": "The Columbine Shooting"
    },
    {
      "id": "events-33",
      "category": "Events",
      "text": "The Sandy Hook Shooting"
    },
    {
      "id": "events-34",
      "category": "Events",
      "text": "The Manchester Arena Bombing"
    },
    {
      "id": "events-35",
      "category": "Events",
      "text": "The London 7/7 Bombings"
    },
    {
      "id": "events-36",
      "category": "Events",
      "text": "The Lockerbie Bombing"
    },
    {
      "id": "events-37",
      "category": "Events",
      "text": "The Boston Marathon Bombing"
    },
    {
      "id": "events-38",
      "category": "Events",
      "text": "The Las Vegas Mass Shooting"
    },
    {
      "id": "events-39",
      "category": "Events",
      "text": "The Watergate Scandal"
    }
  ],
  "People": [
    {
      "id": "people-1",
      "category": "People",
      "text": "Adolf Hitler"
    },
    {
      "id": "people-2",
      "category": "People",
      "text": "Joseph Stalin"
    },
    {
      "id": "people-3",
      "category": "People",
      "text": "Jeffrey Epstein"
    },
    {
      "id": "people-4",
      "category": "People",
      "text": "Harvey Weinstein"
    },
    {
      "id": "people-5",
      "category": "People",
      "text": "Donald Trump"
    },
    {
      "id": "people-6",
      "category": "People",
      "text": "Barack Obama"
    },
    {
      "id": "people-7",
      "category": "People",
      "text": "Tony Blair"
    },
    {
      "id": "people-8",
      "category": "People",
      "text": "Vladimir Putin"
    },
    {
      "id": "people-9",
      "category": "People",
      "text": "Kim Jong Un"
    },
    {
      "id": "people-10",
      "category": "People",
      "text": "OJ Simpson"
    },
    {
      "id": "people-11",
      "category": "People",
      "text": "Prince Andrew"
    },
    {
      "id": "people-12",
      "category": "People",
      "text": "Ted Bundy"
    },
    {
      "id": "people-13",
      "category": "People",
      "text": "Charles Manson"
    },
    {
      "id": "people-14",
      "category": "People",
      "text": "Bernie Madoff"
    },
    {
      "id": "people-15",
      "category": "People",
      "text": "Jack the Ripper"
    },
    {
      "id": "people-16",
      "category": "People",
      "text": "Richard Nixon"
    },
    {
      "id": "people-17",
      "category": "People",
      "text": "Saddam Hussein"
    },
    {
      "id": "people-18",
      "category": "People",
      "text": "Muammar Gaddafi"
    },
    {
      "id": "people-19",
      "category": "People",
      "text": "Mao Zedong"
    },
    {
      "id": "people-20",
      "category": "People",
      "text": "Osama bin Laden"
    },
    {
      "id": "people-21",
      "category": "People",
      "text": "Al Capone"
    },
    {
      "id": "people-22",
      "category": "People",
      "text": "Pablo Escobar"
    },
    {
      "id": "people-23",
      "category": "People",
      "text": "Ghislaine Maxwell"
    },
    {
      "id": "people-24",
      "category": "People",
      "text": "Martin Shkreli"
    },
    {
      "id": "people-25",
      "category": "People",
      "text": "Boris Johnson"
    },
    {
      "id": "people-26",
      "category": "People",
      "text": "Margaret Thatcher"
    },
    {
      "id": "people-27",
      "category": "People",
      "text": "Lance Armstrong"
    },
    {
      "id": "people-28",
      "category": "People",
      "text": "Kanye West"
    },
    {
      "id": "people-29",
      "category": "People",
      "text": "Elizabeth Holmes"
    },
    {
      "id": "people-30",
      "category": "People",
      "text": "P. Diddy"
    },
    {
      "id": "people-31",
      "category": "People",
      "text": "Henry VIII"
    },
    {
      "id": "people-32",
      "category": "People",
      "text": "Emperor Nero"
    },
    {
      "id": "people-33",
      "category": "People",
      "text": "Vlad the Impaler"
    },
    {
      "id": "people-34",
      "category": "People",
      "text": "Rasputin"
    },
    {
      "id": "people-35",
      "category": "People",
      "text": "Genghis Khan"
    },
    {
      "id": "people-36",
      "category": "People",
      "text": "Judas Iscariot"
    },
    {
      "id": "people-37",
      "category": "People",
      "text": "Guy Fawkes"
    },
    {
      "id": "people-38",
      "category": "People",
      "text": "Marie Antoinette"
    },
    {
      "id": "people-39",
      "category": "People",
      "text": "Napoleon Bonaparte"
    },
    {
      "id": "people-40",
      "category": "People",
      "text": "Caligula"
    },
    {
      "id": "people-41",
      "category": "People",
      "text": "Attila the Hun"
    },
    {
      "id": "people-42",
      "category": "People",
      "text": "Ivan the Terrible"
    },
    {
      "id": "people-43",
      "category": "People",
      "text": "Pontius Pilate"
    },
    {
      "id": "people-44",
      "category": "People",
      "text": "Alex Jones"
    },
    {
      "id": "people-45",
      "category": "People",
      "text": "Elon Musk"
    },
    {
      "id": "people-46",
      "category": "People",
      "text": "Andrew Tate"
    },
    {
      "id": "people-47",
      "category": "People",
      "text": "Mark Zuckerberg"
    },
    {
      "id": "people-48",
      "category": "People",
      "text": "Gordon Ramsay"
    },
    {
      "id": "people-49",
      "category": "People",
      "text": "Simon Cowell"
    },
    {
      "id": "people-50",
      "category": "People",
      "text": "Piers Morgan"
    },
    {
      "id": "people-51",
      "category": "People",
      "text": "Logan Paul"
    },
    {
      "id": "people-52",
      "category": "People",
      "text": "Joe Exotic (Tiger King)"
    },
    {
      "id": "people-53",
      "category": "People",
      "text": "Jeffrey Dahmer"
    },
    {
      "id": "people-54",
      "category": "People",
      "text": "John Wayne Gacy"
    },
    {
      "id": "people-55",
      "category": "People",
      "text": "Hannibal Lecter"
    },
    {
      "id": "people-56",
      "category": "People",
      "text": "Voldemort"
    },
    {
      "id": "people-57",
      "category": "People",
      "text": "Satan"
    },
    {
      "id": "people-58",
      "category": "People",
      "text": "Jimmy Savile"
    },
    {
      "id": "people-59",
      "category": "People",
      "text": "Gary Glitter"
    },
    {
      "id": "people-60",
      "category": "People",
      "text": "Rolf Harris"
    },
    {
      "id": "people-61",
      "category": "People",
      "text": "R. Kelly"
    },
    {
      "id": "people-62",
      "category": "People",
      "text": "Jared Fogle (The Subway Guy)"
    },
    {
      "id": "people-63",
      "category": "People",
      "text": "Bill Cosby"
    },
    {
      "id": "people-64",
      "category": "People",
      "text": "Kevin Spacey"
    },
    {
      "id": "people-65",
      "category": "People",
      "text": "Chris Brown"
    },
    {
      "id": "people-66",
      "category": "People",
      "text": "Mel Gibson"
    },
    {
      "id": "people-67",
      "category": "People",
      "text": "Tiger Woods"
    },
    {
      "id": "people-68",
      "category": "People",
      "text": "Prince Harry"
    },
    {
      "id": "people-69",
      "category": "People",
      "text": "Meghan Markle"
    },
    {
      "id": "people-70",
      "category": "People",
      "text": "Gwyneth Paltrow"
    },
    {
      "id": "people-71",
      "category": "People",
      "text": "Jake Paul"
    },
    {
      "id": "people-72",
      "category": "People",
      "text": "Mike Tyson"
    },
    {
      "id": "people-73",
      "category": "People",
      "text": "Hunter Biden"
    },
    {
      "id": "people-74",
      "category": "People",
      "text": "Liz Truss"
    },
    {
      "id": "people-75",
      "category": "People",
      "text": "King Charles III"
    },
    {
      "id": "people-76",
      "category": "People",
      "text": "Queen Elizabeth II"
    },
    {
      "id": "people-77",
      "category": "People",
      "text": "The Pope"
    },
    {
      "id": "people-78",
      "category": "People",
      "text": "Jesus Christ"
    },
    {
      "id": "people-79",
      "category": "People",
      "text": "Pol Pot"
    },
    {
      "id": "people-80",
      "category": "People",
      "text": "Idi Amin"
    },
    {
      "id": "people-81",
      "category": "People",
      "text": "Fidel Castro"
    },
    {
      "id": "people-82",
      "category": "People",
      "text": "Charlie Sheen"
    },
    {
      "id": "people-83",
      "category": "People",
      "text": "Ronald McDonald"
    },
    {
      "id": "people-84",
      "category": "People",
      "text": "Peppa Pig"
    },
    {
      "id": "people-85",
      "category": "People",
      "text": "Santa Claus"
    },
    {
      "id": "people-86",
      "category": "People",
      "text": "Hulk Hogan"
    },
    {
      "id": "people-87",
      "category": "People",
      "text": "George Soros"
    },
    {
      "id": "people-88",
      "category": "People",
      "text": "The Rothchild Family"
    },
    {
      "id": "people-89",
      "category": "People",
      "text": "Joe Biden"
    },
    {
      "id": "people-90",
      "category": "People",
      "text": "Nigel Farage"
    },
    {
      "id": "people-91",
      "category": "People",
      "text": "Marine Le Pen"
    },
    {
      "id": "people-92",
      "category": "People",
      "text": "Your Mom"
    },
    {
      "id": "people-93",
      "category": "People",
      "text": "Sauron"
    },
    {
      "id": "people-94",
      "category": "People",
      "text": "Jason Arday"
    },
    {
      "id": "people-95",
      "category": "People",
      "text": "Scientology"
    },
    {
      "id": "people-96",
      "category": "People",
      "text": "Michel Foucault"
    },
    {
      "id": "people-97",
      "category": "People",
      "text": "Jean-Paul Sartre"
    },
    {
      "id": "people-98",
      "category": "People",
      "text": "Karl Marx"
    },
    {
      "id": "people-99",
      "category": "People",
      "text": "Kanye West"
    },
    {
      "id": "people-100",
      "category": "People",
      "text": "Jim Corr"
    },
    {
      "id": "people-101",
      "category": "People",
      "text": "David Icke"
    }
  ],
  "Places": [
    {
      "id": "places-1",
      "category": "Places",
      "text": "The Gaza Strip"
    },
    {
      "id": "places-2",
      "category": "Places",
      "text": "Auschwitz"
    },
    {
      "id": "places-3",
      "category": "Places",
      "text": "Epstein's Private Island (Little St. James)"
    },
    {
      "id": "places-4",
      "category": "Places",
      "text": "Chernobyl"
    },
    {
      "id": "places-5",
      "category": "Places",
      "text": "Guantanamo Bay"
    },
    {
      "id": "places-6",
      "category": "Places",
      "text": "Alcatraz Island"
    },
    {
      "id": "places-7",
      "category": "Places",
      "text": "The Red Light District"
    },
    {
      "id": "places-8",
      "category": "Places",
      "text": "North Korea"
    },
    {
      "id": "places-9",
      "category": "Places",
      "text": "P. Diddy's Mansion"
    },
    {
      "id": "places-10",
      "category": "Places",
      "text": "The Vatican"
    },
    {
      "id": "places-11",
      "category": "Places",
      "text": "An Unmarked White Van"
    },
    {
      "id": "places-12",
      "category": "Places",
      "text": "Sodom and Gomorrah"
    },
    {
      "id": "places-13",
      "category": "Places",
      "text": "Area 51"
    },
    {
      "id": "places-14",
      "category": "Places",
      "text": "The Kremlin"
    },
    {
      "id": "places-15",
      "category": "Places",
      "text": "Your Mom's Bedroom"
    },
    {
      "id": "places-16",
      "category": "Places",
      "text": "Africa"
    },
    {
      "id": "places-17",
      "category": "Places",
      "text": "Rhodesia"
    },
    {
      "id": "places-18",
      "category": "Places",
      "text": "Abyssinia"
    },
    {
      "id": "places-19",
      "category": "Places",
      "text": "Tanganyika"
    },
    {
      "id": "places-20",
      "category": "Places",
      "text": "Soviet Union (USSR)"
    },
    {
      "id": "places-21",
      "category": "Places",
      "text": "Germany"
    },
    {
      "id": "places-22",
      "category": "Places",
      "text": "Prussia"
    }
  ],
  "Scams": [
    {
      "id": "scams-1",
      "category": "Scams",
      "text": "Bitcoin & Crypto"
    },
    {
      "id": "scams-2",
      "category": "Scams",
      "text": "Pyramid Schemes"
    },
    {
      "id": "scams-3",
      "category": "Scams",
      "text": "Timeshares"
    },
    {
      "id": "scams-4",
      "category": "Scams",
      "text": "Theranos"
    },
    {
      "id": "scams-5",
      "category": "Scams",
      "text": "NFTs"
    },
    {
      "id": "scams-6",
      "category": "Scams",
      "text": "Nigerian Prince Email"
    },
    {
      "id": "scams-7",
      "category": "Scams",
      "text": "Fake Guru Masterclasses"
    },
    {
      "id": "scams-8",
      "category": "Scams",
      "text": "Multi-Level Marketing (MLM)"
    },
    {
      "id": "scams-9",
      "category": "Scams",
      "text": "Psychic Tarot Readings"
    },
    {
      "id": "scams-10",
      "category": "Scams",
      "text": "Payday Loans"
    },
    {
      "id": "scams-11",
      "category": "Scams",
      "text": "Homeopathy"
    },
    {
      "id": "scams-12",
      "category": "Scams",
      "text": "Fake Designer Handbags"
    },
    {
      "id": "scams-13",
      "category": "Scams",
      "text": "Dropshipping \"Mentors\""
    },
    {
      "id": "scams-14",
      "category": "Scams",
      "text": "Cold Calls from \"Microsoft Support\""
    },
    {
      "id": "scams-15",
      "category": "Scams",
      "text": "Catfishing"
    },
    {
      "id": "scams-16",
      "category": "Scams",
      "text": "Ponzi Schemes"
    },
    {
      "id": "scams-17",
      "category": "Scams",
      "text": "Ticket Scalpers"
    },
    {
      "id": "scams-18",
      "category": "Scams",
      "text": "Herbalife"
    },
    {
      "id": "scams-19",
      "category": "Scams",
      "text": "Crypto"
    },
    {
      "id": "scams-20",
      "category": "Scams",
      "text": "Deepfakes"
    },
    {
      "id": "scams-21",
      "category": "Scams",
      "text": "Buying Instagram Followers"
    },
    {
      "id": "scams-22",
      "category": "Scams",
      "text": "Fake Diamond Rings"
    },
    {
      "id": "scams-23",
      "category": "Scams",
      "text": "Phishing Texts from \"Your Bank\""
    },
    {
      "id": "scams-24",
      "category": "Scams",
      "text": "Snake Oil"
    },
    {
      "id": "scams-25",
      "category": "Scams",
      "text": "Miracle Baldness Cures"
    },
    {
      "id": "scams-26",
      "category": "Scams",
      "text": "Cult Indoctrination"
    },
    {
      "id": "scams-27",
      "category": "Scams",
      "text": "\"Hot Singles in Your Area\" Ads"
    },
    {
      "id": "scams-28",
      "category": "Scams",
      "text": "Video Game Loot Boxes"
    },
    {
      "id": "scams-29",
      "category": "Scams",
      "text": "Free Trials That Automatically Charge You"
    },
    {
      "id": "scams-30",
      "category": "Scams",
      "text": "Fake 5-Star Reviews"
    },
    {
      "id": "scams-31",
      "category": "Scams",
      "text": "Psychic Medium Séances"
    },
    {
      "id": "scams-32",
      "category": "Scams",
      "text": "Fake Charity Collection Buckets"
    },
    {
      "id": "scams-33",
      "category": "Scams",
      "text": "Dodgy Crypto Meme Coins"
    },
    {
      "id": "scams-34",
      "category": "Scams",
      "text": "Sam Bankman-Fried's FTX Exchange"
    },
    {
      "id": "scams-35",
      "category": "Scams",
      "text": "The Panama Papers"
    },
    {
      "id": "scams-36",
      "category": "Scams",
      "text": "The Paradise Papers"
    },
    {
      "id": "scams-37",
      "category": "Scams",
      "text": "Miracle Autism Cures"
    }
  ],
  "Things": [
    {
      "id": "things-1",
      "category": "Things",
      "text": "Cancer"
    },
    {
      "id": "things-2",
      "category": "Things",
      "text": "AIDS"
    },
    {
      "id": "things-3",
      "category": "Things",
      "text": "Vegan Food"
    },
    {
      "id": "things-4",
      "category": "Things",
      "text": "Explosive Diarrhoea"
    },
    {
      "id": "things-5",
      "category": "Things",
      "text": "Bed Bugs"
    },
    {
      "id": "things-6",
      "category": "Things",
      "text": "A Root Canal"
    },
    {
      "id": "things-7",
      "category": "Things",
      "text": "A Colonoscopy"
    },
    {
      "id": "things-8",
      "category": "Things",
      "text": "Rabies"
    },
    {
      "id": "things-9",
      "category": "Things",
      "text": "A Crying Baby on an Aeroplane"
    },
    {
      "id": "things-10",
      "category": "Things",
      "text": "A Hangover"
    },
    {
      "id": "things-11",
      "category": "Things",
      "text": "Food Poisoning"
    },
    {
      "id": "things-12",
      "category": "Things",
      "text": "Stepping on a Lego Brick Barefoot"
    },
    {
      "id": "things-13",
      "category": "Things",
      "text": "Head Lice"
    },
    {
      "id": "things-14",
      "category": "Things",
      "text": "A Broken Condom"
    },
    {
      "id": "things-15",
      "category": "Things",
      "text": "Tapeworms"
    },
    {
      "id": "things-16",
      "category": "Things",
      "text": "Unsolicited Nudes"
    },
    {
      "id": "things-17",
      "category": "Things",
      "text": "Public Urination"
    },
    {
      "id": "things-18",
      "category": "Things",
      "text": "Kidney Stones"
    },
    {
      "id": "things-19",
      "category": "Things",
      "text": "A Botched Plastic Surgery"
    },
    {
      "id": "things-20",
      "category": "Things",
      "text": "An Unplanned Pregnancy"
    },
    {
      "id": "things-21",
      "category": "Things",
      "text": "Asbestos"
    },
    {
      "id": "things-22",
      "category": "Things",
      "text": "Genital Warts"
    },
    {
      "id": "things-23",
      "category": "Things",
      "text": "Chlamydia"
    },
    {
      "id": "things-24",
      "category": "Things",
      "text": "The Morning-After Pill"
    },
    {
      "id": "things-25",
      "category": "Things",
      "text": "Accidental Incest"
    },
    {
      "id": "things-26",
      "category": "Things",
      "text": "A Wet Fart"
    },
    {
      "id": "things-27",
      "category": "Things",
      "text": "Third-Degree Burns"
    },
    {
      "id": "things-28",
      "category": "Things",
      "text": "Adult Incontinence"
    },
    {
      "id": "things-29",
      "category": "Things",
      "text": "Sniffing Glue"
    },
    {
      "id": "things-30",
      "category": "Things",
      "text": "An Enema"
    },
    {
      "id": "things-31",
      "category": "Things",
      "text": "Cockroach Infestation"
    },
    {
      "id": "things-32",
      "category": "Things",
      "text": "A Stolen Kidney"
    },
    {
      "id": "things-33",
      "category": "Things",
      "text": "An Electric Chair"
    },
    {
      "id": "things-34",
      "category": "Things",
      "text": "A Straightjacket"
    },
    {
      "id": "things-35",
      "category": "Things",
      "text": "Scurvy"
    },
    {
      "id": "things-36",
      "category": "Things",
      "text": "Leprosy"
    },
    {
      "id": "things-37",
      "category": "Things",
      "text": "The Bubonic Plague"
    },
    {
      "id": "things-38",
      "category": "Things",
      "text": "A Ball Gag"
    },
    {
      "id": "things-39",
      "category": "Things",
      "text": "REALDOLLS"
    },
    {
      "id": "things-40",
      "category": "Things",
      "text": "A Vasectomy"
    },
    {
      "id": "things-41",
      "category": "Things",
      "text": "A Guillotine"
    },
    {
      "id": "things-42",
      "category": "Things",
      "text": "A Rusty Needle"
    },
    {
      "id": "things-43",
      "category": "Things",
      "text": "A Restraining Order"
    },
    {
      "id": "things-44",
      "category": "Things",
      "text": "An Ankle Tag"
    },
    {
      "id": "things-45",
      "category": "Things",
      "text": "A Snuff Film"
    },
    {
      "id": "things-46",
      "category": "Things",
      "text": "A Black Site"
    },
    {
      "id": "things-47",
      "category": "Things",
      "text": "A Hit List"
    },
    {
      "id": "things-48",
      "category": "Things",
      "text": "Buttplug"
    },
    {
      "id": "things-49",
      "category": "Things",
      "text": "Dildo"
    },
    {
      "id": "things-50",
      "category": "Things",
      "text": "Whip"
    },
    {
      "id": "things-51",
      "category": "Things",
      "text": "Asylum Seekers"
    },
    {
      "id": "things-52",
      "category": "Things",
      "text": "Refugees"
    },
    {
      "id": "things-53",
      "category": "Things",
      "text": "Super AIDS"
    },
    {
      "id": "things-54",
      "category": "Things",
      "text": "Christianity"
    },
    {
      "id": "things-55",
      "category": "Things",
      "text": "Hinduism"
    },
    {
      "id": "things-56",
      "category": "Things",
      "text": "Buddhism"
    },
    {
      "id": "things-57",
      "category": "Things",
      "text": "Islam"
    },
    {
      "id": "things-58",
      "category": "Things",
      "text": "Sikhism"
    },
    {
      "id": "things-59",
      "category": "Things",
      "text": "Judaism"
    },
    {
      "id": "things-60",
      "category": "Things",
      "text": "Phrenology"
    },
    {
      "id": "things-61",
      "category": "Things",
      "text": "Eugenics"
    },
    {
      "id": "things-62",
      "category": "Things",
      "text": "Genocide"
    },
    {
      "id": "things-63",
      "category": "Things",
      "text": "Ticketmaster"
    },
    {
      "id": "things-64",
      "category": "Things",
      "text": "ISIS"
    },
    {
      "id": "things-65",
      "category": "Things",
      "text": "Al-Qaeda"
    }
  ]
}),
  totalCards: 365
});
